import { Component, Input, OnInit } from "@angular/core"
import { Category } from "src/app/models"
import { DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { ObjectKeysPipe } from "../../pipes/object-keys.pipe";
import { CategoryNamesPipe } from "../../pipes/category-names.pipe"
import { MatIcon } from "@angular/material/icon"

@Component({
    selector: "valben-categories-history",
    templateUrl: "./categories-history.component.html",
    styles: [`
        b {
            white-space: nowrap;
        }
    `],
    standalone: true,
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatIcon,
        DatePipe,
        ObjectKeysPipe,
        CategoryNamesPipe,
    ],
})

export class CategoriesHistoryComponent implements OnInit {
    @Input() values: Category[] = []
    langs: string[] = []

    ngOnInit(): void {
        this.langs = this.values.map(_ => "hr")
    }
}

